import { AddToCartComponent } from './components/add-to-cart/add-to-cart.component';
import { AuthModule } from '../auth/auth.module';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { CartService } from './services/cart/cart.service';
import { CartConfigService, CartConfigServiceOption } from './services/cart-config/cart-config.service';
import { CartHomeButtonComponent } from './components/cart-home-button/cart-home-button.component';
import { CartProfileButtonComponent } from './components/cart-profile-button/cart-profile-button.component';
import { CartRouting } from './cart-routing';
import { CartComponent } from './components/cart/cart.component';
import { CommanditaireComponent } from './components/commanditaire/commanditaire.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { CommonModule } from '@angular/common';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormOptionComponent } from './components/form-option/form-option.component';
import { GlobalModule } from '@argalis-apps/angular-global';
import { GridModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { OneCartComponent } from './components/one-cart/one-cart.component';
import { ParticipantComponent } from './components/participant/participant.component';
import { NombreParticipantComponent } from './components/nombre-participant/nombre-participant.component';
import { Routes, RouterModule } from '@angular/router';
import { ReservationComponent } from './components/reservation/reservation.component';
import { WindowModule } from '@progress/kendo-angular-dialog';
import { ProfileInformationsService } from '../account/services/profile-informations/profile-informations.service';

@NgModule({
    declarations: [
        AddToCartComponent,
        CartComponent,
        CartHomeButtonComponent,
        CartProfileButtonComponent,
        CommanditaireComponent,
        ConfirmationComponent,
        FormOptionComponent,
        OneCartComponent,
        ParticipantComponent,
        ReservationComponent,
        NombreParticipantComponent
    ],
    exports: [
        AddToCartComponent,
        CartComponent,
        CartHomeButtonComponent,
        CartProfileButtonComponent,
        CommanditaireComponent,
        ConfirmationComponent,
        FormOptionComponent,
        ParticipantComponent,
        ReservationComponent,
        NombreParticipantComponent
    ],
    imports: [
        AuthModule,
        ButtonsModule,
        CommonModule,
        DatePickerModule,
        DropDownsModule,
        FormsModule,
        GlobalModule,
        GridModule,
        InputsModule,
        RouterModule,
        ReactiveFormsModule,
        WindowModule
    ],
    providers: [CartService, ProfileInformationsService]
})
export class CartModule {
  public static moduleRouting(config?: CartConfigServiceOption): Routes {
    return CartRouting;
  }
  public static forRoot(config?: CartConfigServiceOption): ModuleWithProviders<CartModule> {
    return {
      ngModule: CartModule,
      providers: [
        {
          provide: CartConfigServiceOption,
          useValue: config
        },
        CartService,
        CartConfigService
      ]
    };
  }
}
